<template>
  <div>
    <div class="row" :class="statusMargin ? 'mt-3' : ''">
      <div class="col-12 col-sm-12 col-md-4">
        <span class="me-auto font-logo text-nowrap">
          <slot name="label"></slot>
        </span>
      </div>
      <div
        class="col-12 col-sm-12 col-md-8 text-start text-sm-start text-md-end mt-1 mt-sm-1 mt-md-0"
      >
        <div class="text-break">
          <slot name="message"></slot>
        </div>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
export default {
  name: "App",
  props: {
    label: {
      type: String,
      default: () => ""
    },
    message: {
      type: String,
      default: () => ""
    },
    statusMargin: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {};
  },
  methods: {},
  computed: {},
  watch: {},
  components: {}
};
</script>

<style></style>
